import { render, staticRenderFns } from "./LoginSuccess.vue?vue&type=template&id=420c5991&scoped=true"
import script from "./LoginSuccess.vue?vue&type=script&lang=js"
export * from "./LoginSuccess.vue?vue&type=script&lang=js"
import style0 from "./LoginSuccess.vue?vue&type=style&index=0&id=420c5991&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "420c5991",
  null
  
)

export default component.exports